// client/src/services/bankAccountService.js
import api from './api';

const bankAccountService = {
  getBankAccounts: async () => {
    const response = await api.get('/bank-accounts');
    return response.data;
  },
  
  getBankAccount: async (id) => {
    const response = await api.get(`/bank-accounts/${id}`);
    return response.data;
  },
  
  createBankAccount: async (bankAccountData) => {
    const response = await api.post('/bank-accounts', bankAccountData);
    return response.data;
  },
  
  updateBankAccount: async (id, bankAccountData) => {
    const response = await api.put(`/bank-accounts/${id}`, bankAccountData);
    return response.data;
  },
  
  deleteBankAccount: async (id) => {
    const response = await api.delete(`/bank-accounts/${id}`);
    return response.data;
  }
};

export default bankAccountService;